<template>
	<el-dialog :visible.sync="dialogVisible" width="400px" :before-close="handleClose">
		<template v-slot:title>
			<div class="flex flex-align-center">
				<div>设置分成比</div>
				<explain class="fz-12 yx-color-text-regular ml-4" :content="tooltip" />
			</div>
		</template>
		<div class="content">
			<div class="alert">
				<i class="iconfont active icon-a-info-circlexinxi-mian"></i>
				<div class="ml-8">每天仅可修改1次</div>
			</div>
			<el-radio-group class="mt-24" v-model="showRate">
				<el-radio :label="1">设置分成比</el-radio>
				<el-radio :label="0">不设置分成比</el-radio>
			</el-radio-group>
			<el-form v-show="showRate" class="mt-24" :model="form" :rules="rules" ref="ruleForm" label-width="80px" hide-required-asterisk>
				<el-form-item prop="rate">
					<template v-slot:label>
						<span class="flex flex-align-center">
							<explain class="fz-12 yx-color-text-regular mr-4" :content="tooltip" />
							<span>分成比</span>
						</span>
					</template>
					<el-input v-model="form.rate" autocomplete="off" placeholder="请输入" maxlength="5">
						<template slot="append">%</template>
					</el-input>
				</el-form-item>
			</el-form>
		</div>
		<span slot="footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="submit">确 认</el-button>
		</span>
	</el-dialog>
</template>

<script>
import explain from '@/components/common/explain';
import { setMerchantsRate } from '@/api/shopManage';

export default {
	name: 'zsRateDialog',
	components: {
		explain,
	},
	data() {
		return {
			dialogVisible: false,
			tooltip:
				'系统根据所设分成比自动统计提成，提成=订单金额*服务费率*分成比，自动扣除技术服务费10%（快手侧扣除0），招商运营侧将换算成提成比【服务费率*分成比】展示，当月提成按最新分成比统计',
			showRate: 1,
			form: {
				rate: '',
			},
			rules: {
				rate: { required: true, message: '请输入分成比', trigger: 'blur' },
			},
		};
	},
	methods: {
		show(userId, rate) {
			this.userId = userId;
			this.form.rate = rate;
			this.dialogVisible = true;
		},
		handleClose() {
			this.showRate = 1;
			this.form = {
				rate: '',
			};
			this.$refs.ruleForm.resetFields();
			this.dialogVisible = false;
		},
		submit() {
			if (!this.showRate) return this.setMerchantsRate(false);
			this.$refs.ruleForm.validate(async valid => {
				if (!valid) return;
				this.setMerchantsRate(true);
			});
		},
		async setMerchantsRate(isSet) {
			const { userId } = this;
			const params = { ...this.form, userId };
			if (!isSet) params.rate = '0';
			const { code } = await setMerchantsRate(params);
			if (code !== 0) return;
			this.$message.success('设置完成，本月数据支持切换设置后重新计算，上月以及之前数据不支持切换后重算');
			this.$emit('refresh');
			this.handleClose();
		},
	},
};
</script>

<style lang="less" scoped>
.content {
	padding: 8px;
	.alert {
		display: flex;
		align-items: center;
		border: 1px solid #fba543;
		border-radius: 4px;
		background-color: #fef3e7;
		height: 40px;
		line-height: 40px;
		padding: 0 16px;
		box-sizing: border-box;
		font-size: 14px;
		color: #333;
		.active {
			color: #fa8f14;
		}
	}
}
</style>
